<template>
    <div style="width:100%" class="mb-4">

        <v-card class="mx-auto" width="100%">
            <v-card-text>
                <div class="text-h5">PostSev Report (by SME)</div>
            </v-card-text>

            <!--<v-card-actions>
                <v-btn text
                       color="accent"
                       @click="onOpenPostSevReport">
                    PostSev report: {{$route.params.id }}
                </v-btn>
            </v-card-actions>-->


            <div class="pa-4">

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Added By</v-list-item-title>
                        <v-list-item-subtitle>{{data.psrOpenedBy}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Incident</v-list-item-title>
                        <v-list-item-subtitle>{{data.incidentId}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Severity</v-list-item-title>
                        <v-list-item-subtitle>{{data.incidentSeverity}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Channel</v-list-item-title>
                        <v-list-item-subtitle>{{data.remedyChannel}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Date</v-list-item-title>
                        <v-list-item-subtitle> {{data.incidentStartDate | DateTime}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Affected Market</v-list-item-title>
                        <v-list-item-subtitle> {{data.affectedMarket}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>


                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Affected Operator</v-list-item-title>
                        <v-list-item-subtitle> {{data.affectedOperator}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>


                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Affected Operator</v-list-item-title>
                        <v-list-item-subtitle> {{data.affectedOperator}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Root Cause</v-list-item-title>
                        <v-list-item-subtitle> {{data.rootCause}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Summary</v-list-item-title>
                        <v-list-item-subtitle style="white-space: wrap;"> {{data.incidentSummary}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Technical Details</v-list-item-title>
                        <v-list-item-subtitle style="white-space: wrap;"> {{data.incidentTechnical}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Solution</v-list-item-title>
                        <v-list-item-subtitle style="white-space: wrap;"> {{data.incidentSolution}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>


                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Impact</v-list-item-title>
                        <v-list-item-subtitle>
                            {{data.customerImpact}}
                            <div class="mt-2">
                                <v-dialog>
                                    <template v-slot:activator="{ on, attrs }">

                                        <img style="max-width:100%;" :src="data.incidentImage" v-bind="attrs" :alt="data.incidentId"
                                             v-on="on" />
                                    </template>

                                    <v-card>
                                        <v-card-text>
                                            <img style="width:100%;" :src="data.incidentImage" :alt="data.incidentId" />
                                        </v-card-text>
                                    </v-card>
                                </v-dialog>
                            </div>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Duration</v-list-item-title>
                        <v-list-item-subtitle>
                            MTTR/MTTC (Minutes)

                            <div>
                                <pie-chart ref="pieChart" semi-mode :show-percent="false" :data="pieData"></pie-chart>
                            </div>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Monitoring</v-list-item-title>
                        <v-list-item-subtitle> {{data.remedyMonitoringInfo}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Associated CRQ</v-list-item-title>
                        <v-list-item-subtitle> {{data.remedyCrq}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Preventatives</v-list-item-title>
                        <v-list-item-subtitle style="white-space: wrap;"> {{data.incidentPreventatives}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Team</v-list-item-title>
                        <v-list-item-subtitle> {{data.responsibleTeam}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>


            </div>


        </v-card>

    </div>
</template>

<script>
    import PieChart from "../../components/charts/PieChart"
    export default {
        name: 'PostSev',
        data: function () {
            return {

                headers: [
                    { text: 'Incident', value: 'incident' },
                    { text: 'Date', value: 'logged' },
                    { text: 'Customer Perspective', value: 'customerPerspective' },
                    { text: 'Root Cause', value: 'rootCause' },
                    { text: 'Affected Operator', value: 'affectedOperator' },
                    { text: 'Assigned Team', value: 'assignedTeam' },
                    { text: 'Bets', value: 'bets' },
                    { text: 'Registration', value: 'reg' },
                    { text: 'Login', value: 'login' },
                    { text: 'Banking', value: 'banking' },
                    { text: 'Other', value: 'other' },
                    { text: 'Other List', value: 'otherImpactList' },
                    { text: 'Comment', value: 'comment' },
                    { text: 'Assignee', value: 'assignee' },
                    { text: 'Sign Off', value: 'signOff' },
                    { text: 'Updater', value: 'updater' },
                ],
            }
        },
        components: {
            PieChart
        },
        props: {
            data: {
                default: () => {},
                type: Object
            },
            pieData: {
                default: () => [],
                type: Array
            },
        },
        computed: {
            affectedOperatorArray() {
                if (!this.data.affectedOperator) return [];
                return this.data.affectedOperator.replace("[", "").replace("]", "").replace(/"/g, "").split(',').filter(operator => operator !== "");
            }
        },
        methods: {
            async onOpenPostSevReport() {
                window.open(`https://postsev.derivco.com/${this.$route.params.id}`);
            }
        }
    }
</script>
